import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import {TranslateContext} from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

    @Input('isPositive') isPositive: boolean;
	translateContext: TranslateContext = TranslateContext.CORE;

    constructor() { }

    ngOnInit() {
    }

}
